// src/patterns/CodeEditor.jsx
import React, { useState } from "react";
import { FiFileText, FiCopy } from "react-icons/fi";
import { Highlight, themes } from "prism-react-renderer";

const languageColors = {
  jsx: "text-blue-500",
  js: "text-orange-50",
  html: "text-orange-500",
  css: "text-purple-500",
  default: "text-gray-400",
};

const availableThemes = {
  dark: themes.nightOwl,
  light: themes.github,
};

export const CodeEditor = ({
  filename = "code.js",
  language = "js",
  children,
  sketch = false,
  theme = "dark",
}) => {
  const langClass = languageColors[language] || languageColors.default;
  const codeString = (children || "").trim();
  const [copied, setCopied] = useState(false);
  const selectedTheme = availableThemes[theme] || availableThemes.dark;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(codeString);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  return (
    <div
      className={`rounded-xl overflow-hidden font-mono text-sm transition-all duration-500 animate-fade-in ${sketch ? "border-2 border-dashed border-black" : "border border-black"} bg-white`}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-2 border-b border-black bg-gray-100">
        <div className="flex items-center space-x-2">
          <FiFileText className="text-gray-500" />
          <span className="text-gray-800">{filename}</span>
        </div>
        <div className="flex items-center gap-4">
          <span className={`uppercase text-xs ${langClass}`}>{language}</span>
          <button
            onClick={handleCopy}
            className="text-xs text-gray-500 hover:text-black focus:outline-none"
          >
            {copied ? "✓ Kopiert" : <FiCopy />}
          </button>
        </div>
      </div>

      {/* Code Block */}
      <Highlight theme={selectedTheme} code={codeString} language={language}>
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <pre className={`${className} p-4 overflow-x-auto`} style={style}>
            {tokens.map((line, i) => (
              <div key={i} {...getLineProps({ line, key: i })}>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </div>
            ))}
          </pre>
        )}
      </Highlight>
    </div>
  );
};

export default CodeEditor;
